import Slider from '@material-ui/core/Slider';
import {
  createMuiTheme,
  MuiThemeProvider,
  withStyles,
} from '@material-ui/core/styles';
import { HarmonyEvent } from '@spotify-internal/harmony';
import React, { PureComponent } from 'react';
import { connect } from 'unistore/full/react';
import actions from './actions';
import './PlaybackProgress.css';
import { Tooltip } from '@material-ui/core';

const theme = createMuiTheme({
  palette: {
    primary: { main: '#fff' },
  },
});

export default connect(
  ({
    harmony,
    currentRow,
    playerState: { timestamp: playerTimestamp } = {},
  }) => ({
    harmony,
    currentRow,
    playerTimestamp,
  }),
  actions
)(
  class PlaybackProgress extends PureComponent {
    state = {
      progress: null,
    };

    componentDidMount() {
      this.refresh();
    }

    componentDidUpdate(prevProps) {
      if (prevProps.harmony !== this.props.harmony) this.refresh();

      if (prevProps.playerTimestamp !== this.props.playerTimestamp) {
        this.setState({
          pendingProgress: null,
        });
      }
    }

    componentWillUnmount() {
      this.props.harmony.removeListener(
        HarmonyEvent.PROGRESS,
        this.handleProgress
      );

      this.props.harmony.removeListener(
        HarmonyEvent.STATE_CHANGED,
        this.handleHarmonyStateChanged
      );
    }

    async refresh() {
      if (!this.props.harmony) return;
      this.props.harmony.on(HarmonyEvent.PROGRESS, this.handleProgress);
      this.props.harmony.on(
        HarmonyEvent.STATE_CHANGED,
        this.handleHarmonyStateChanged
      );
    }

    handleHarmonyStateChanged = async () => {
      const playerState = await this.props.harmony.getCurrentState();
      if (playerState) this.handleProgress({ data: playerState });
    };

    handleProgress = async ({
      data: { position: progress, timestamp } = {},
    } = {}) => {
      const { track_window: { current_track: { duration_ms } = {} } = {} } =
        (await this.props.harmony.getCurrentState()) || {};
      this.setState({ progress, timestamp, duration_ms });
    };

    handleSliderChange = (event, pendingProgress) => {
      this.setState({ pendingProgress: Math.round(pendingProgress) });
      if (this.props.onChange) this.props.onChange(pendingProgress);
    };

    handleChangeCommited = () => {
      this.props.seekTo(this.state.pendingProgress);
      this.setState({
        pendingTimestamp: this.props.playerTimestamp,
      });
      if (this.props.onChangeCommited)
        this.props.onChangeCommited(this.state.pendingProgress);
    };

    render() {
      const { progress = 0, pendingProgress, duration_ms } = this.state;
      const currentTrackUri = this.props.currentRow?.track?.uri;

      return (
        <MuiThemeProvider theme={theme}>
          <div className="PlaybackProgress">
            <Slider
              value={Math.min(
                duration_ms,
                pendingProgress === null ? progress : pendingProgress
              )}
              max={duration_ms}
              aria-labelledby="Playback Progress"
              onChange={this.handleSliderChange}
              onChangeCommitted={this.handleChangeCommited}
              disabled={!currentTrackUri}
              classes={{
                thumb: 'PlaybackProgress__thumb',
              }}
              valueLabelDisplay="auto"
            />
            <div className="PlaybackProgress__timestamps">
              <span>
                {formatTime(
                  pendingProgress === null ? progress : pendingProgress
                )}
              </span>
              <span>{formatTime(duration_ms)}</span>
            </div>
          </div>
        </MuiThemeProvider>
      );
    }
  }
);

const formatTime = (time) =>
  time == null
    ? '-:--'
    : `${Math.floor(time / 1000 / 60)}:${Math.round((time / 1000) % 60)
        .toString()
        .padStart(2, '0')}`;
